export default __webpack_public_path__ + "static/media/view-forward.b097d5b6.png";